import type {ShareableType} from './resource-name';

export class BdChildResourceHelper {

  public static merge(
    oldChildResources: { [resourceName in ShareableType]?: string[] },
    newChildResources: { [resourceName in ShareableType]?: string[] }
  ): { [resourceName in ShareableType]?: string[] } {
    const childResourceNames = Object.keys(newChildResources);

    childResourceNames.forEach(childResourceName => {
      if (!oldChildResources[childResourceName]) {
        oldChildResources[childResourceName] = newChildResources[childResourceName];
      } else {
        const newChildResourceIds = newChildResources[childResourceName]
          .filter((id: string) => oldChildResources[childResourceName].indexOf(id) === -1);

        oldChildResources[childResourceName] = oldChildResources[childResourceName].concat(newChildResourceIds);
      }
    });

    return oldChildResources;
  }

  public static flatten(
    childResources: { [resourceName in ShareableType]?: string[] }
  ): { resourceName: ShareableType, resourceId: string }[] {
    const resourceNames: ShareableType[] = Object.keys(childResources) as ShareableType[];
    const result: { resourceName: ShareableType, resourceId: string }[] = [];

    resourceNames.forEach(resourceName => {
      childResources[resourceName].forEach((id: string) => {
        result.push({
          resourceName,
          resourceId: id
        });
      });
    });

    return result;
  }
}
